import TagIds from '~/constants/common/tagIds';
import { InventoryTypeId, InventoryTypeKey } from '~/constants/inventoryType';
import { StatusTagEnum } from './StatusTag';

const TWO_HOURS = 7200;

export function getPurchaseStatus(vehicleUnlockDateTime: string | undefined): {
  isLocked: boolean;
  isOnHold: boolean;
} {
  if (vehicleUnlockDateTime == null) {
    return {
      isLocked: false,
      isOnHold: false
    };
  }

  const timeLeft = Date.parse(vehicleUnlockDateTime) - +new Date();

  return {
    isLocked: Math.floor(timeLeft / 1000) >= TWO_HOURS,
    isOnHold: Math.floor(timeLeft / 1000) < TWO_HOURS
  };
}

type OwnProps = {
  vehicleInventoryType: InventoryTypeId | InventoryTypeKey;
  vehicleTags?: Array<{
    tagId: number;
    tagCategoryId: number;
    tagKey: string;
    tagName: string;
    tagDescription: string;
    tagToolTip: string;
    sortOrder: number;
    isResultTileDisplayable: boolean;
  }>;
  vehicleUnlockDateTime?: string;
};

export default function getStatusTag({
  vehicleInventoryType,
  vehicleTags = [],
  vehicleUnlockDateTime
}: OwnProps): StatusTagEnum | null {
  const { isLocked: showLockedTag, isOnHold: showOnHoldTag } =
    getPurchaseStatus(vehicleUnlockDateTime);
  const showPreOrderTag =
    showOnHoldTag || showLockedTag
      ? false
      : vehicleInventoryType === InventoryTypeId.WIP ||
        vehicleInventoryType === InventoryTypeKey.WIP;
  const showRecentlyAdded = vehicleTags.some(
    tag => tag.tagId === TagIds.RecentlyAdded
  );

  switch (true) {
    case showOnHoldTag:
      return StatusTagEnum.Hold;
    case showPreOrderTag:
      return StatusTagEnum.Reservable;
    case showLockedTag:
      return StatusTagEnum.Locked;
    case showRecentlyAdded:
      return StatusTagEnum.Recent;
    default:
      return null;
  }
}
